import styled, { css } from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { PopoverContent, Tab, TabsCarousel } from "@similarweb/ui-components";

export const StyledCountWrapper = styled.div<{ isWide?: boolean }>`
    box-sizing: border-box;
    min-width: 20px;
    height: 20px;
    margin-left: 8px;
    padding: ${({ isWide }) => (isWide ? "0 4px" : 0)};
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 13px;
    background-color: ${colorsPalettes.blue["400"]};
    ${setFontVariant("captionTitle", colorsPalettes.carbon[0])};
`;

export const StyledTab = styled(Tab).attrs<{ "data-automation"?: string; "data-automation-selected"?: boolean }>(({ selected }) => ({
    "data-automation": "tab",
    "data-automation-selected": selected,
}))`
    max-height: 48px;
    padding: 12px 0;

    &:hover:not(.selected),
    &:hover:not(.selected) * {
        color: ${colorsPalettes.carbon["400"]};

        ${StyledCountWrapper} {
            color: ${colorsPalettes.carbon[0]};
        }
    }

    &.selected {
        color: ${colorsPalettes.blue["400"]};

        &:last-child:after {
            width: 100%;
        }
    }

    &.disabled {
        .SWReactIcons svg path {
            fill: ${colorsPalettes.carbon[100]};
        }
    }

    * {
        text-transform: none;
    }
`;

export const StyledTabTitle = styled.div<{ withDD?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    ${setFontVariant("tab", "inherit")};
    white-space: nowrap;
    padding: 4px 24px;
    ${({ withDD }) =>
        withDD &&
        css`
            cursor: pointer;
        `}
`;

export const StyledTabsCarousel = styled(TabsCarousel)<{ isSticky: boolean }>`
    & button {
        left: 0;
        right: 0;
        box-shadow: none;
        border-radius: 0;
        background-color: ${({ isSticky }) => (isSticky ? colorsPalettes.carbon[0] : colorsPalettes.bluegrey[100])};
        &:hover {
            box-shadow: none;
        }
        &:active {
            box-shadow: none;
        }
    }
`;

export const StyledTabsContainer = styled.div<{ isSticky: boolean }>`
    z-index: 20;
    position: sticky;
    top: 0;

    ${({ isSticky }) =>
        isSticky &&
        css`
            background-color: ${colorsPalettes.carbon[0]};
            border-bottom: 1px solid ${colorsPalettes.carbon[50]};

            ul {
                border: none;
            }
        `}
`;

export const StyledTabsWrapper = styled.div`
    max-width: 1366px;
    margin: 0 auto;
    padding: 0 43px;
    @media (max-width: 768px) {
        padding: 0 10px;
    }
`;

export const StyledTabsAnchorRef = styled.div`
    height: 1px;
`;

export const StyledPopoverContent = styled(PopoverContent)`
    padding: 0;
    margin: 0;
    width: 320px;
    max-height: 378px;
    overflow-y: auto;
`;
